import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon8 from '../ReactIcons/icon8';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon8 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon8 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon8;